/**
 * @file: 层板商品从右到左排列布局
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import FrontCubeData from '../../frontCubeData/index';
import Utils from '../../utils/util';
import { containSubGoodsSizeByCubeId } from '../goods/index';
import { textareaSize } from '../textarea/index';
import { cubeModify } from '../../update/cubeModify';
import { layerLink } from '../../interaction/layerGroup/link';
import { layerCubeSize } from '../size/index';

export default function rightToLeft(layoutTask: Array<LayoutTask>): void {
    layoutTask.forEach((task: LayoutTask): void => {
        layout(task.layerId, task.width);
    });
}

function layout(layerId: CubeId, layerWidth: PhysicsMeasurement): void {
    let layoutCubeIds: Array<CubeId> = CubeTree.getChildCubeIds(layerId);
    let prevPos: number = startLeftCompute(layerId, layerWidth);

    for (let i = layoutCubeIds.length - 1; i >= 0; i--) {
        let cubeId: CubeId = layoutCubeIds[i];
        let layoutCubeSize: PhysicsSize = layerCubeSize(cubeId);

        if (CubeTree.isBafflePlate(cubeId)) {
            prevPos = FrontCubeData.getNumberValue(cubeId, 'posX');
        }
        else {
            prevPos = Utils.math(prevPos, layoutCubeSize.width, '-');
        }

        prevPos = Utils.toFixedNumber(prevPos, 2);
        cubeModify(cubeId, {
            posWidth: 0,
            posX: prevPos,
            posY: 0
        });
    }
}

// 起始坐标计算
function startLeftCompute(layerId: CubeId, layerWidth: PhysicsMeasurement): PhysicsMeasurement {
    let extendRight: number = FrontCubeData.getNumberValue(layerId, 'extendRight');
    let link: LinkedListInstance|null = layerLink(layerId);

    if ((link && link.isLast(layerId)) || !link) {
        return Utils.math(layerWidth, extendRight, '+');
    }

    return layerWidth;
}
